<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
    </div>
		
    <van-empty
      v-if="listShow"
      :description="$t('moneybag.detailsEmpty')"
    />
    <div
      v-if="data"
      class="detail_box"
    >
      <div
        v-for="item in data"
        v-if="item.show==1"
        class="item"
      >
        <div class="de_wrap">
          <p class="tit">
            {{ item[lang] }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="item.type =='1'?'del':''"
          v-html="item.type =='1'?' '+ parseInt(item.money) : '-'+' '+ parseInt(item.money)"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Funds",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: null,
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                frozen: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
			this.$parent.footer('moneybag');
        },
        mounted() {
            Fetch('/user/funds').then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                for (var i in r.data.reason) {
					switch (i) {
					    case "1":
							r.data.reason[i] = this.$t('moneybag.recharge');
					    	break;
					    case "2":
							r.data.reason[i] = this.$t('moneybag.withdraw');
					    	break;
						case "3":
							r.data.reason[i] = this.$t('moneybag.give');
					   	 	break;
						case "4":
							r.data.reason[i] = this.$t('moneybag.signIn');
					    	break;
						case "5":
							r.data.reason[i] = this.$t('moneybag.share');
					    	break;
					    case "6":
							r.data.reason[i] = this.$t('moneybag.purchase');
					    	break;
						case "7":
							r.data.reason[i] = this.$t('moneybag.redPacket');
					   	 	break;
						case "8":
							r.data.reason[i] = this.$t('moneybag.reward');
					    	break;
						case "9":
							r.data.reason[i] = this.$t('moneybag.welfare');
					    	break;
					    case "10":
							r.data.reason[i] = this.$t('moneybag.invite');
					    	break;
						case "11":
						case "12":
							r.data.reason[i] = this.$t('moneybag.income');
					   	 	break;
					    default:
					    	break;
					
					}
                    this.option.push({
                        text: r.data.reason[i],
                        value: i
                    })
                }
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = parseInt(1*r.data.money + 1*r.data.wx_bankbz);
                this.mymoney = r.data.mymoney;
                this.frozen = r.data.basemoney;
                this.userName = r.data.username;
				this.listd(1);
            })
        },
        methods: {
			listd(type){
				var dataf = this.data;
				this.data = null;
				if(dataf && dataf.length>0){
					if(type==1){
						for(var i=0;i<dataf.length;i++){
							dataf[i].show = 1;
						}
					}else if(type==2){
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type !=3 && dataf[i].reason_type !=4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}else{
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type ==3 || dataf[i].reason_type ==4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}
				}
				this.data = dataf;
			},
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
		height: 44px;
    }
	.user_yw{
		text-align: center;
		width: 96%;
		margin-top: 20px;
		background: #0063d2;
		margin-left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
        display: flex;
		color: #FFF;
        div{
            width: 100%;
        }
		p:nth-child(1){
			font-size: 14px;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 14px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		background: #0063d2;
		margin-left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
			font-size: 14px;
		}
	}

    .detail_box {
        width: 96%;
		margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 10px;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
	.user_money{
		display: block;
		width: 96%;
		margin-left: 2%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			    justify-content: center;
			}
		}
	}
	.but1 {
    background-color: #ffcd00;
    color: #232f3e;
}
.but2 {
    background-color: #232f3e;
    color: #ffcd00;
}

.rp_box {
    display: flex;
    padding-left: 28px;
    padding-right: 28px;
    margin: 11px;
    height: 210px;
    background-color: #0064d3;
    border-radius: 15px;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    padding-bottom: 3px;
	.topRightIcon{
	    position: absolute;
	    top: 5px;
	    right: 5px;
	    width: 177px;
		height: 118px;
	}
	.rp_title{
	    font-size: 16px;
	    color: #fff;
	    margin-bottom: 5px;
	}
	.rp_money {
	    display: flex;
	    align-items: center;
	    color: #fff;
	    font-size: 16px;
	    font-weight: 700;
		img{
			height: 28px;
			width: 28px;
			margin-right: 11px;
		}
	}
	 .rp_tips{
	    font-size: 12px;
	    font-family: PingFangSC-Regular,PingFang SC;
	    font-weight: 400;
	    color: #fff;
	    margin-top: 11px;
		line-height: 20px;
	}
}
.top_box{
    background: #fff;
    box-shadow: 0 2px 8px 7px rgba(0,0,0,.06);
	.header_box{
	    display: flex;
	    padding: 11px 22px;
	    justify-content: space-between;
		.title_box {
		    display: flex;
		    align-items: center;
			img{
			    width: 68px;
			    height: 68px;
			}
		}
		.title {
		    display: flex;
		    align-items: center;
		    margin-left: 17px;
		    font-weight: 600;
		    font-size: 16px;
		}
	}
}
.btn_box {
    display: flex;
    justify-content: space-around;
    margin: 17px 11px 0;
	.btn {
	    flex: 1;
	    height: 40px;
	    background: #0064d3;
	    border-radius: 8px;
	    font-size: 14px;
	    font-weight: 400;
	    color: #fff;
	}
	.flexCenter {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.btn1 {
	    margin-left: 17px;
	    color: #fff;
	    background: #0064d3;
	}
}
.manager_box{
    margin: 34px 11px 0;
	.box{
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    border-bottom: 1px solid #d2d2d2;
	    padding-left: 9px;
	    height: 57px;
		.icon{
		    display: flex;
			img{
				width: 20px;
				height: 20px;
			}
			div{
				margin-left: 17px;
				font-size: 14px;
				font-weight: 400;
				color: #333;
			}
		}
		.right img{
		    width: 8px;
		    height: 14px;
		}
	}
}
</style>
